import { FC, useContext, useEffect, useState } from 'react';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { ConsentContent } from 'templates/ConsentContent';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { GetAuditionResponse } from 'hooks/u002/useGetAuditionHooks';
import { AppContext } from 'templates/AppContextProvider';
import { useGetAgreementText } from 'hooks/u002/useGetAgreementTextHooks';
import LoadingModal from 'organisms/LoadingModal';
import MessageModal from 'organisms/MessageModal';
import Cookies from 'js-cookie';

//U002F04 特定利用同意画面
type SpecificUseConsentProps = {
  audition: GetAuditionResponse & {
    audition_id: string;
  };
  onNext: () => void;
  onBack: () => void;
};
export const UnauthSpecificUseConsent: FC<SpecificUseConsentProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const [checked, setChecked] = useState(false);
  const { audition } = props;
  const { currentLang } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [specificUseConsent, loading, err] = useGetAgreementText({
    audition_id: audition.audition_id,
    examination_no: audition.examination_no,
    lang: currentLang,
    consent_type: '2', // 2: 特定利用同意
  });

  const handleNext = () => {
    Cookies.remove('userBirthday');
    props.onNext();
  };

  const handleChange = (checked: boolean) => {
    setChecked(checked);
  };
  useEffect(() => {
    if (err) {
      setErrorMessage(err.message);
    }
  }, [err]);

  return (
    <>
      {loading && <LoadingModal />}
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tAuditionForm('TU002_032')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <AppLogoHeader />
      <ConsentContent
        title={tAuditionForm('TU002_007')}
        text={specificUseConsent?.consent_text}
        label={tAuditionForm('TU002_046')}
        nextLabel={tAuditionForm('TU002_047')}
        backLabel={tAuditionForm('TU002_048')}
        checked={checked}
        onChange={handleChange}
        onBack={props.onBack}
        onNext={handleNext}
      />
      <UnauthAppFooter />
    </>
  );
};
